// Admin refund review: labels and input checks. The server enforces every rule; these only avoid pointless requests and wording drift.
export const STATUS_LABEL = {
  pending_review: "Menunggu keputusan", clawback_pending: "Penarikan berjalan", completed_clawback: "Kredit sudah ditarik",
  closed_no_clawback: "Ditutup tanpa penarikan", rejected: "Ditolak (bukan refund)",
};
export const FINAL = ["completed_clawback", "closed_no_clawback", "rejected"];
export const DECISION_LABEL = { clawback: "Tarik kredit", no_clawback: "Tutup tanpa penarikan", reject: "Tolak refund" };
export const statusLabel = (status) => STATUS_LABEL[status] || "Status tidak dikenal";
export const isFinal = (status) => FINAL.includes(status);
export const NOTE_MIN = 5;
export const NOTE_MAX = 500;

// Returns an error message, or "" when the input may be sent. `granted` = credits the order gave; `balance` = the user's current balance (null if unknown).
export const validateDecision = ({ decision, note, credits, granted, credited }) => {
  if (!DECISION_LABEL[decision]) return "Pilih keputusan.";
  const text = String(note || "").trim();
  if (text.length < NOTE_MIN || text.length > NOTE_MAX) return `Catatan wajib diisi (${NOTE_MIN}-${NOTE_MAX} karakter).`;
  if (decision === "clawback") {
    if (!credited) return "Pesanan ini tidak pernah memberi kredit. Pilih tutup tanpa penarikan.";
    if (credits !== "" && credits != null) {
      const n = Number(credits);
      if (!Number.isInteger(n) || n < 1 || n > granted) return `Jumlah kredit harus bilangan bulat 1 sampai ${granted}.`;
    }
  }
  return "";
};
export const errorText = (error) => (typeof error?.response?.data?.detail === "string" ? error.response.data.detail : "Permintaan belum berhasil. Coba lagi.");
export const confirmText = ({ decision, credits, granted }) => {
  if (decision === "clawback") return `Tarik ${credits === "" || credits == null ? granted : credits} kredit dari saldo pengguna? Ini dicatat di ledger dan tidak dapat dibatalkan dari layar ini. Pengembalian uang ke pelanggan tidak dilakukan oleh sistem.`;
  if (decision === "no_clawback") return "Tutup tinjauan ini tanpa menarik kredit? Keputusan ini final.";
  return "Tolak refund ini (bukan refund yang sah)? Keputusan ini final.";
};
